<script setup>
import { defineModel } from 'vue';
import { useI18n } from 'vue-i18n';

defineProps({
  errors: {
    type: String,
    default: null,
    required: false,
  },
});

const { t } = useI18n();

const model = defineModel({ type: String });

const categoryKeys = ['MARKETING', 'UTILITY', 'AUTHENTICATION'];

// Map the keys to an array of objects with key and label
const categoryOptions = categoryKeys.map(key => ({
  key,
  label: t(`WHATSAPP_TEMPLATES.CATEGORIES.${key}`), // Use i18n to fetch the label
}));
</script>

<template>
  <label>
    {{ $t('WHATSAPP_TEMPLATES.ADD.FIELDS.CATEGORY.LABEL') }}
    <select v-model="model" class="action__question" required>
      <option value="" disabled selected>
        {{ $t('WHATSAPP_TEMPLATES.ADD.FIELDS.CATEGORY.PLACEHOLDER') }}
      </option>
      <option
        v-for="(category, index) in categoryOptions"
        :key="index"
        :value="category.key"
      >
        {{ category.label }}
      </option>
    </select>

    <p v-if="errors" class="text-red-400">
      {{ errors }}
    </p>
  </label>
</template>
